import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { DashboardContext } from "./DashboardContext";
import { AppContext } from "../../appContext";
import "./DashboardSearches.css";

interface IDashboardSearchesProps{
}

export const DashboardSearches = ()=>{
    const [searchInput, setSearchInput] = useState('');
    const [isFocused, setFocused] = useState(false);
    const dashboardContext = useContext(DashboardContext);
    const { translate } = useContext(AppContext);
    const {
        setSelectedClientId, setActivePopup,
        applySearch
    } = dashboardContext;
    
    useEffect(()=>{
        let timerId: ReturnType<typeof setTimeout>;
        timerId = setTimeout(()=>{
            applySearch(searchInput);
        }, 500);
        return ()=>{
            clearInterval(timerId);
        }
    }, [searchInput]);

    return (
        <div className="dashboard_searches">
            <div className={`dashboard_searches_search ${isFocused ? 'dashboard_searches_search--focus': '' }`}>
                <div 
                    className="dashboard_searches_search_icon"
                    onClick={() => {
                        setSearchInput('');
                    }}
                    style={{ cursor: 'pointer' }}
                >

                </div>
                <input 
                    className="dashboard_searches_search_input" 
                    placeholder={translate('search_clients_placeholder')} 
                    value={searchInput} 
                    onChange={(e)=>{
                        setSearchInput(e.target.value);
                    }}
                    onFocus={()=>{
                        setFocused(true)
                    }}
                    onBlur={()=>{
                        setFocused(false)
                    }}
                >

                </input>
            </div>
            <div className="button dashboard_searches_add" onClick={()=>{
                setActivePopup('AddClient'); 
                setSelectedClientId(null)
            }}>

            </div>
        </div>
    )
}